// import roll from '../../../images/minigames/roll.svg'
import { SlotsButtonStyled, SlotsContainerStyled, SlotsRollsStyled } from './slots.styles'
import { useRef, useState } from 'react'
import Roll from './roll/roll'
import Award from '../award/award'

const Slots = ({pause, resume}) => {
    const [animate, setAnimate] = useState(false)
    const [showAward, toggleAward] = useState(false)

    const startAnimation = () => {
        pause()
        setAnimate(true)
        setTimeout(() => {
            resume()
            toggleAward(true)
        }, 3200)
    }

    return (
        <>
            <SlotsContainerStyled className='mt-14 md:mt-0'>
                <SlotsRollsStyled>
                    <Roll animate={animate} duration={'1s'} amount={1000} initial_position={0} />
                    <Roll animate={animate} duration={'2s'} amount={2200} initial_position={100} />
                    <Roll animate={animate} duration={'3s'} amount={3000} initial_position={200} />
                </SlotsRollsStyled>
                <SlotsButtonStyled onClick={startAnimation}>SPIN</SlotsButtonStyled>
            </SlotsContainerStyled>
            {showAward && <Award />}
        </>
    )
}

export default Slots